import React from 'react'
import { Modal } from 'react-bootstrap'

function ImagePreviewModal({showImageModal, setShowImageModal, selectedImage}) {
  return (
    <Modal 
  show={showImageModal} 
  onHide={() => setShowImageModal(false)} 
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Image Preview</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ textAlign: "center" }}>
    {selectedImage && (
      <img 
        src={selectedImage} 
        alt="preview" 
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
    )}
  </Modal.Body>
</Modal>
  )
}

export default ImagePreviewModal